module.exports = __webpack_public_path__ + "img/tour-checks.d2c366cc.jpg";